import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestAccommodationsConsole = loadable(
  () => import(/* webpackChunkName: "content/accommodations/guest-console" */ './GuestAccommodationsConsole'),
  'GuestAccommodationsConsole',
);
